function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M205.18 88.1245C208.904 84.4112 215.035 84.4112 218.867 88.1245C222.54 91.7881 222.591 97.7901 219.018 101.622L220.757 99.8885L221.071 99.5508L222.647 97.9986L222.924 97.7015L224.537 96.1087L224.777 95.854L226.427 94.2188L226.607 94.0268L228.317 92.3289L228.438 92.2015L230.206 90.439C233.931 86.6167 233.931 80.4984 230.206 76.785C226.375 73.0717 220.244 73.0717 216.519 76.785L214.629 78.675L212.739 80.5649L210.85 82.4548L208.96 84.3447L207.07 86.2346L205.18 88.1245Z",
  fill: "url(#paint0_linear_20015976_52919)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M123.153 112.701H151.374C152.381 112.701 153.352 112.321 154.091 111.636L156.254 109.634C156.993 108.95 157.963 108.57 158.971 108.57H160.829H181.474C182.475 108.57 183.446 108.394 184.346 108.042C184.885 107.83 185.398 107.556 185.874 107.219C186.115 107.048 186.347 106.861 186.568 106.658L186.949 106.277L186.657 106.574C186.627 106.603 186.598 106.63 186.568 106.658L175.61 117.616C174.187 119.145 172.215 119.91 170.135 119.91H123.153C121.182 119.91 119.539 118.271 119.539 116.305C119.539 114.339 121.182 112.701 123.153 112.701Z",
  fill: "url(#paint1_linear_20015976_52919)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M79.4895 89.5979L77.5996 91.4878L70.0391 99.0483C72.9959 96.2083 76.8289 94.5699 80.9905 94.5699H152.941C157.727 94.5699 161.623 98.2172 162.001 102.89C162.04 103.378 161.906 103.86 161.669 104.288L159.889 107.496C159.622 107.979 159.971 108.571 160.522 108.571C160.719 108.571 160.907 108.491 161.043 108.349L171.493 97.5035C171.954 97.0249 172.371 96.498 172.634 95.8877C173.107 94.7876 173.369 93.574 173.369 92.2962C173.369 87.2724 169.32 83.2305 164.281 83.2305H92.3313C90.076 83.2305 87.9166 83.7122 85.9418 84.6036C84.2696 85.3585 82.7341 86.4068 81.3794 87.7079L79.4895 89.5979Z",
  fill: "url(#paint2_linear_20015976_52919)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.92382 164.223L70.0391 99.0481C72.996 96.2081 76.829 94.5697 80.9905 94.5697H152.941C157.979 94.5697 162.031 98.6112 162.031 103.636C162.031 108.66 157.979 112.702 152.941 112.702H123.153C121.182 112.702 119.54 114.34 119.54 116.306C119.54 118.272 121.182 119.911 123.153 119.911H170.135C172.216 119.911 174.187 119.146 175.611 117.617L205.18 88.1252C208.903 84.4114 215.036 84.4114 218.869 88.1252C222.592 91.839 222.592 97.9558 218.869 101.779L180.21 140.337C177.254 143.286 173.311 144.924 169.259 144.924H87.6709C83.5094 144.924 79.5669 146.563 76.7195 149.512L8.38516 215.124C5.42828 218.073 0.390625 215.998 0.390625 211.847L0.500139 167.5C0.500139 166.298 1.04771 165.097 1.92382 164.223Z",
  fill: "url(#paint3_linear_20015976_52919)"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_20015976_52919)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143 35.5C143 35.667 142.999 35.8336 142.996 36C142.999 36.1664 143 36.333 143 36.5C143 43.8633 140.474 50.6364 136.24 56H86.7597C82.5264 50.6364 80 43.8633 80 36.5C80 36.333 80.0013 36.1664 80.0039 36C80.0013 35.8336 80 35.667 80 35.5C80 18.103 94.103 4 111.5 4C128.897 4 143 18.103 143 35.5Z",
  fill: "#717883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143 37.5C143 54.897 128.897 69 111.5 69C94.103 69 80 54.897 80 37.5C80 20.103 94.103 6 111.5 6C128.897 6 143 20.103 143 37.5Z",
  fill: "url(#paint4_linear_20015976_52919)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.84 49.1877L118.82 40.9562L127.951 38.5096L126.945 34.7563L97.0015 42.7797L98.0072 46.533L107.138 44.0863L103.442 55.7253L108.174 54.4574L112.516 40.7918L123.109 50.4556L127.84 49.1877ZM125.969 31.1134L124.963 27.36L116.017 29.7572L119.669 18.2484L114.9 19.5262L110.534 33.3956L99.8176 23.5676L95.0487 24.8454L103.966 32.9863L95.0196 35.3834L96.0352 39.1735L125.969 31.1134Z",
  fill: "#111827"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_20015976_52919)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M208 65.5C208 65.667 207.999 65.8336 207.996 66C207.999 66.1664 208 66.333 208 66.5C208 73.8633 205.474 80.6364 201.24 86H151.76C147.526 80.6364 145 73.8633 145 66.5C145 66.333 145.001 66.1664 145.004 66C145.001 65.8336 145 65.667 145 65.5C145 48.103 159.103 34 176.5 34C193.897 34 208 48.103 208 65.5Z",
  fill: "#717883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208 67.5C208 84.897 193.897 99 176.5 99C159.103 99 145 84.897 145 67.5C145 50.103 159.103 36 176.5 36C193.897 36 208 50.103 208 67.5Z",
  fill: "url(#paint5_linear_20015976_52919)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.924 63.2767C191.528 59.2838 188.457 57.1373 184.257 55.7054L185.619 50.2965L182.294 49.476L180.967 54.7423C180.093 54.5267 179.195 54.3232 178.303 54.1216L179.638 48.8205L176.314 48L174.951 53.407C174.227 53.2438 173.517 53.0825 172.827 52.9128L172.831 52.8959L168.244 51.7622L167.36 55.2787C167.36 55.2787 169.827 55.8386 169.775 55.8733C171.122 56.2062 171.366 57.0886 171.325 57.7881L169.773 63.95C169.866 63.9734 169.987 64.0072 170.119 64.0597C170.008 64.0325 169.89 64.0025 169.768 63.9734L167.593 72.6053C167.428 73.0104 167.01 73.6181 166.069 73.3874C166.102 73.4352 163.651 72.7901 163.651 72.7901L162 76.5588L166.328 77.6269C167.133 77.8267 167.922 78.0358 168.699 78.2327L167.323 83.7035L170.645 84.524L172.008 79.1114C172.915 79.3552 173.796 79.5802 174.658 79.7922L173.3 85.1795L176.626 86L178.002 80.5395C183.674 81.602 187.938 81.1735 189.733 76.0956C191.18 72.0071 189.661 69.6486 186.678 68.1108C188.851 67.6147 190.488 66.1996 190.924 63.2767ZM183.325 73.8253C182.297 77.9139 175.343 75.7036 173.089 75.1494L174.915 67.9016C177.17 68.4587 184.399 69.5614 183.325 73.8253ZM184.354 63.2176C183.416 66.9367 177.628 65.0472 175.751 64.5839L177.407 58.0104C179.284 58.4736 185.331 59.3382 184.354 63.2176Z",
  fill: "#111827"
}));

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_20015976_52919",
  x: 72,
  y: 0,
  width: 79,
  height: 81,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20015976_52919"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20015976_52919",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_20015976_52919",
  x: 137,
  y: 30,
  width: 79,
  height: 81,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20015976_52919"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20015976_52919",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20015976_52919",
  x1: 208.432,
  y1: 82.5046,
  x2: 224.024,
  y2: 98.0964,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#535C6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.234375,
  stopColor: "#414956"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78125,
  stopColor: "#404855"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#404C62"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20015976_52919",
  x1: 186.698,
  y1: 106.128,
  x2: 122.913,
  y2: 106.128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2C3443"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.755208,
  stopColor: "#101520"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20015976_52919",
  x1: 73.3021,
  y1: 91.0098,
  x2: 127.637,
  y2: 145.345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F6875"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.104167,
  stopColor: "#424B58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.796875,
  stopColor: "#2D333A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854167,
  stopColor: "#25292E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10131A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_20015976_52919",
  x1: 101.488,
  y1: 94,
  x2: 101.488,
  y2: 175.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#262F44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19202E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_20015976_52919",
  x1: 111.5,
  y1: 6,
  x2: 111.5,
  y2: 69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#515C6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#283344"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_20015976_52919",
  x1: 176.5,
  y1: 36,
  x2: 176.5,
  y2: 99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#515C6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.791667,
  stopColor: "#313C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#111926"
})));

function SvgBorrowBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 151,
    viewBox: "0 0 233 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowBg);
export default __webpack_public_path__ + "static/media/borrowBg.95f69cd855feb932b643680f2151babc.svg";
export { ForwardRef as ReactComponent };